<template>
  <el-container class="body_container">
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex" class="body_title">
        <el-col>微信公众号自定义菜单</el-col>
      </el-row>
    </el-header>
    <el-row style="margin-bottom: 20px">
      <el-form :model="searchVo" ref="search" :inline="true">
        <el-tooltip class="item" effect="dark" content="新建一级菜单" placement="right">
          <el-button  @click="addFuColumn()" type="primary" icon="el-icon-plus">新建菜单</el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="更新微信公众号自定义菜单" placement="right">
          <el-button  @click="updateMenu()" type="primary" icon="el-icon-plus">更新菜单</el-button>
        </el-tooltip>
        <!--<span style="font-size:5px;">注：微信规定自定义菜单最多包括3个一级菜单，每个一级菜单最多包含5个二级菜单。一级菜单最多4个汉字，二级菜单最多7个汉字，多出来的部分将会以“...”代替。</span>-->
      </el-form>
    </el-row>
    <el-main class="search_result">
      <el-table :data="columns"  style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="name" label="菜单标题" min-width="150px"></el-table-column>
        <el-table-column prop="type" label="菜单类型" :formatter="formatterColumn" width="180px"></el-table-column>
        <el-table-column prop="url" label="URL"  min-width="150px"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间"  min-width="150px"></el-table-column>
        <el-table-column prop="id" label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.pid === 0">
              <el-tooltip class="item" effect="dark" content="添加二级菜单" placement="left">
                <i class="el-icon-plus" @click="addColumn(scope.row)" style="font-size: 16px;color: #333;cursor: pointer"></i>
              </el-tooltip>
            &nbsp;
            <i class="el-icon-edit" @click="checkColumn(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i class="el-icon-delete" @click="delColumn(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            </span>
            <span v-else>
               <i class="el-icon-edit" @click="checkColumn(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
               <i class="el-icon-delete" @click="delColumn(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog :append-to-body="true" :visible.sync="menuDialog" :show-close="false" width="40%" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
        class="el-dialog__close el-icon el-icon-close"></i></button>
      <el-form :model="wechatMenu" ref="floatForm" style="margin:0px auto;width: 90%">
        <el-form-item label="名称" label-width="105px" prop="name" :rules="[
          { required: true, message: '请输入名称', trigger: 'blur' },
           { min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' }
        ]">
          <el-input v-model="wechatMenu.name" autocomplete="off"></el-input>
        </el-form-item>
        <div v-if="wechatMenu.type === 'view'">
          <el-form-item label="URL" label-width="105px">
            <el-input v-model="wechatMenu.url" autocomplete="off" placeholder="必填"></el-input>
          </el-form-item>
        </div>
        <div v-if="wechatMenu.type === 'media_id'">
          <el-form-item label="图片" label-width="105px">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :http-request="uploadLecturerPhoto"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :limit="1"
              :file-list="fileList"
              list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="类型" label-width="105px">
          <el-select  style="width:100%" v-model="wechatMenu.type" @change="getSelected">
            <el-option label="网页" value="view"></el-option>
            <el-option label="小程序" value="miniprogram"></el-option>
            <el-option label="点击" value="click"></el-option>
            <el-option label="图片" value="media_id"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="wechatMenu.type === 'miniprogram'">
          <el-form-item label="小程序APPID" label-width="105px">
            <el-input v-model="wechatMenu.appid" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="小程序页面路径" label-width="105px">
            <el-input v-model="wechatMenu.pagepath" autocomplete="off"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="loading" type="primary" :loading="true">保存中</el-button>
        <el-button v-else type="primary" @click="save('floatForm')" >保存</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import wechat from '@/api/wechat'
import store from '@/store/index'
import video from '@/api/video'
export default {
  name: 'Index',
  data () {
    return {
      columns: [],
      loading: false,
      // isshow: false,
      // showUrl: false,
      // showImg: false,
      menuDialog: false,
      photoParam: null,
      searchVo: {},
      fileList: [],
      wechatMenu: {
        id: null,
        type: 'view',
        name: null,
        url: null,
        appid: null,
        pagepath: null,
        siteId: null,
        pid: null,
        grade: null,
        img: null
      }
    }
  },
  methods: {
    checkColumn (row) {
      wechat.load({id: row.id}).then(res => {
        if (res.data.code === 0) {
          this.menuDialog = true
          this.wechatMenu = res.data.data
          if (this.wechatMenu.img !== null && this.wechatMenu.img !== ''){
            let upLoadImg = {
              url: this.wechatMenu.img
            }
            this.fileList.push(upLoadImg)
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    delColumn (row) {
      this.$confirm('此操作将删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.children.length>0){
          this.$message.error('该菜单有子菜单，无法删除')
          return
        } else {
          wechat.del({id: row.id}).then(res => {
            this.$message.info(res.data.message)
            if (res.data.code === 0){
              this.reload()
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    reload () {
      let obj = {}
      wechat.find(obj).then(res => {
        this.columns = res.data.data
      })
    },
    addColumn (row) {
      if (row.children.length < 5) {
        this.menuDialog = true
        this.wechatMenu.pid = row.id
        this.wechatMenu.grade = '2'
      } else {
        this.$message.error('最多只能包括5个二级菜单')
      }
    },
    addFuColumn () {
      if (this.columns.length < 3) {
        this.menuDialog = true
        this.wechatMenu.grade = '1'
        this.wechatMenu.pid = '0'
      } else {
        this.$message.error('最多只能包括3个一级菜单')
      }
    },
    formatterColumn (row, column) {
      return row.type === 'view' ? '网页' : row.type === 'miniprogram' ? '小程序' : row.type === 'click' ? '点击' : row.type === 'media_id' ? '图片' : '未知'
    },
    // 类型下拉框选择事件
    getSelected (value) {
      // if (this.wechatMenu.type === 'miniprogram') {
      //   this.isshow = true
      // } else {
      //   this.isshow = false
      // }
      // if (this.wechatMenu.type === 'view') {
      //   this.showUrl = true
      // } else {
      //   this.showUrl = false
      // }
      // if (this.wechatMenu.type === 'click') {
      //   this.showImg = true
      // } else {
      //   this.showImg = false
      // }
    },
    cancelModal () {
      // 关闭弹窗
      this.menuDialog = false
      this.fileList = []
      this.$refs['floatForm'].resetFields();
      // this.isshow = false
      // this.showImg = false
      // this.showUrl = false
      this.wechatMenu = {
        id: null,
        type: 'view',
        name: null,
        url: null,
        appid: null,
        pagepath: null,
        pid: null,
        grade: null
      }
    },
    // 更新公众号菜单
    updateMenu () {
      this.$confirm('此操作将更新微信公众号菜单，确定更新吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        wechat.updateMenu().then(res => {
          // console.log(res.data)
          this.$message.info(res.data.errmsg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    uploadLecturerPhoto () {
      video.uploadPhoto(this.photoParam).then(res => {
        if (res.data.code===0){
          this.$message.success('图片保存成功')
          let photoUrl = res.data.data
          photoUrl = photoUrl.replace(/\\/g,'/')
          // console.log(photoUrl)
          let upLoadImg = {
            url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/' + photoUrl
          }
          this.fileList.push(upLoadImg)
          this.wechatMenu.img = 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/' + photoUrl
        }else {
          this.$message.info('图片保存失败')
        }
      })
    },
    // 上传图片
    beforeUpload(file) {
      //重新写一个表单上传的方法
      this.photoParam = new FormData();
      this.photoParam.append('file', file, file.name)
      // return false;
    },
    handleRemove(file, fileList) {
      this.fileList = []
      this.wechatMenu.img = ''
    },
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          wechat.save(this.wechatMenu).then(res => {
            this.loading = false
            this.$message.info(res.data.message)
            if (res.data.code === 0){
              this.cancelModal()
              this.reload()
            }
          })
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created () {
    this.reload()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/system/WechatMenu.vue